import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface City {
  id: number;
  name: string;
} // Use number if your API uses numbers
interface CitiesState {
  list: City[];
}
const initialState: CitiesState = { list: [] };

const citiesSlice = createSlice({
  name: "cities",
  initialState,
  reducers: {
    setCities: (state, action: PayloadAction<City[]>) => {
      state.list = action.payload;
    },
  },
});
export const { setCities } = citiesSlice.actions;
export default citiesSlice.reducer;
